export const scaleUp = {
  scale: 1.5,
  duration: 0.5,
  ease: 'bounce',
};

export const scaleDown = {
  scale: 1,
  duration: 0.5,
  ease: 'bounce',
};

export const fadeIn = {
  y: -100,
  opacity: 0,
  stagger: 0.6,
  duration: 8,
  delay: 1,
};
